import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { Modal, Tooltip, OverlayTrigger } from 'react-bootstrap';
import AnalyteDetails from './analyteDetails';
import Swal from 'sweetalert2';
import { ModalStyled } from '../../../../theme/customizedStyleComponents';
import { deleteAnalyte } from '../../../../services/clinicPortalServices/analyteService';
import { fetchQcRanges } from '../../../../services/clinicPortalServices/qcRangeService';
import QcRangeDetails from '../../qc/qcRangeGrid/qcRangeDetails';
import { ThemeContext } from '../../../../theme/ThemeProvider';
import { AgGridReact } from 'ag-grid-react';
import { colorSchemeDark, colorSchemeLight, themeQuartz } from 'ag-grid-community';
import moment from 'moment';
import EditBtnCellRendererForQcRange from '../../qc/qcRangeGrid/editBtnCellRenderer';
import { qcControlTypes } from '../../../../services/common/optionsData';
import { serviceConstants } from '../../../../services/common/constants';
import { trackRecentView } from '../../../../services/clinicPortalServices/recentViewService';

const themeLight = themeQuartz.withPart(colorSchemeLight);
const themeDark = themeQuartz.withPart(colorSchemeDark);

export default class EditBtnCellRenderer extends Component {
    constructor(props) {
        super(props);

        this.state = {
            show: false,
            showPanel: false,
            analyteId: props.data._id,
            showQcPopup: false,
            showQcCreatePopup: false,
            matchingQcRanges: [],
            columnDefs: [
                {
                    headerName: 'Actions',
                    minWidth: 150,
                    maxWidth: 150,
                    cellStyle: { textAlign: 'center' },
                    cellRenderer: 'editBtnCellRenderer'
                },
                {
                    headerName: 'Name',
                    minWidth: 150,
                    resizable: true,
                    valueGetter: (params) => {
                        return params.data.analyteId.name + ' - ' + params.data.controlType;
                    }
                },
                {
                    headerName: 'Analyte',
                    minWidth: 150,
                    resizable: true,
                    valueGetter: (params) => {
                        return params.data.analyteId.name;
                    }
                },
                {
                    headerName: 'Control Type',
                    minWidth: 150,
                    resizable: true,
                    field: 'controlType'
                },
                {
                    headerName: 'Result Type',
                    minWidth: 150,
                    resizable: true,
                    field: 'resultType'
                },
                {
                    headerName: 'Minimum Valid Range',
                    minWidth: 150,
                    resizable: true,
                    valueGetter: (params) => {
                        if (params.data.targetValue && params.data.sdValue) {
                            return Number(params.data.targetValue) - Number(params.data.sdValue) * 2;
                        }
                    }
                },
                {
                    headerName: '- 10% Range',
                    minWidth: 150,
                    resizable: true,
                    valueGetter: (params) => {
                        if (params.data.targetValue && params.data.sdValue) {
                            return Number(params.data.targetValue) - Number(params.data.sdValue);
                        }
                    }
                },
                {
                    headerName: 'Target Value',
                    minWidth: 150,
                    resizable: true,
                    field: 'targetValue'
                },
                {
                    headerName: '+ 10% Range',
                    minWidth: 150,
                    resizable: true,
                    valueGetter: (params) => {
                        if (params.data.targetValue && params.data.sdValue) {
                            return Number(params.data.targetValue) + Number(params.data.sdValue);
                        }
                    }
                },
                {
                    headerName: 'Maximum Valid Range',
                    minWidth: 150,
                    resizable: true,
                    valueGetter: (params) => {
                        if (params.data.targetValue && params.data.sdValue) {
                            return Number(params.data.targetValue) + Number(params.data.sdValue) * 2;
                        }
                    }
                },
                {
                    headerName: 'SD',
                    minWidth: 150,
                    resizable: true,
                    field: 'sdValue'
                },
                {
                    headerName: 'Result Choices',
                    minWidth: 150,
                    resizable: true,
                    field: 'resultChoices'
                },
                {
                    headerName: 'Valid Values',
                    minWidth: 150,
                    resizable: true,
                    field: 'validValues'
                },
                {
                    headerName: 'Creation Date',
                    minWidth: 150,
                    resizable: true,
                    valueGetter: (params) => {
                        return moment
                            .tz(params.data.createdAt, serviceConstants.SYSTEM_TIME_ZONE)
                            .format('MM/DD/YYYY hh:mm:ss A');
                    }
                },
                {
                    headerName: 'Created By',
                    minWidth: 150,
                    resizable: true,
                    field: 'createdBy'
                }
            ],
            components: {
                editBtnCellRenderer: EditBtnCellRendererForQcRange
            }
        };
    }

    handleDelete = () => {
        Swal.fire({
            title: 'Are you sure?',
            text: 'You will not be able to recover this anlayte!',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes, delete it!',
            cancelButtonText: 'No, keep it',
            customClass: {
                container:
                    window.localStorage.getItem('appTheme') === 'Dark' &&
                    /clinic|lims/.test(window.location.pathname.split('/')[1]) &&
                    'dark-swal',
                cancelButton: 'order-1',
                confirmButton: 'order-2'
            }
        }).then((result) => {
            if (result.isConfirmed) {
                deleteAnalyte({
                    _id: this.state.analyteId,
                    name: this.props.data.name
                }).then((res) => {
                    this.props.context.componentParent.loadGridData();
                });
            }
        });
    };

    handleShow = () => {
        this.setState({ show: true });
        // Track recent view
        const analyte = this.props.data;
        if (analyte) {
            trackRecentView('analyte', analyte._id, analyte.name || 'Analyte', '/clinic/quantitativeAnalyte');
        }
    };

    handleClose = () => {
        this.setState({ show: false });
    };

    handleShowQcRangePopup = () => {
        this.setState({ showQcPopup: true });
        this.loadQcRanges();
    };

    loadQcRanges = () => {
        fetchQcRanges().then((res) => {
            this.setState({
                matchingQcRanges: res.data.filter((item) => {
                    return item.analyteId._id === this.props.data._id;
                })
            });
        });
    };

    handleCloseQcRangePopup = () => {
        this.setState({ showQcPopup: false });
    };

    handleShowQcRangeCreatePopup = () => {
        this.setState({ showQcCreatePopup: true });
    };

    handleCloseQcRangeCreatePopup = () => {
        this.setState({ showQcCreatePopup: false });
        this.loadQcRanges();
    };

    renderPanel() {
        const d = this.props.data;
        const ps = { overlay: { position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.3)', zIndex: 1040 }, panel: { position: 'fixed', top: 0, right: 0, width: '420px', height: '100vh', background: '#fff', boxShadow: '-4px 0 20px rgba(0,0,0,0.15)', zIndex: 1041, display: 'flex', flexDirection: 'column', overflowY: 'auto' }, header: { padding: '16px 20px', borderBottom: '1px solid #e0e0e0', display: 'flex', alignItems: 'center', justifyContent: 'space-between', background: '#f8f9fa' }, title: { margin: 0, fontSize: '16px', fontWeight: 600, color: '#333' }, body: { padding: '20px', flex: 1 }, section: { marginBottom: '20px' }, sectionTitle: { fontSize: '11px', fontWeight: 700, color: '#888', letterSpacing: '0.08em', textTransform: 'uppercase', marginBottom: '10px', paddingBottom: '6px', borderBottom: '1px solid #eee' }, dl: { display: 'grid', gridTemplateColumns: '150px 1fr', rowGap: '8px', margin: 0 }, dt: { fontSize: '13px', color: '#555', fontWeight: 600, paddingRight: '8px' }, dd: { fontSize: '13px', color: '#222', margin: 0 }, editBtn: { background: '#0066cc', color: '#fff', border: 'none', borderRadius: '4px', padding: '6px 14px', fontSize: '13px', cursor: 'pointer', marginRight: '8px' }, closeBtn: { background: 'transparent', border: 'none', fontSize: '18px', cursor: 'pointer', color: '#666' } };
        return ReactDOM.createPortal(
            <>
                <div style={ps.overlay} onClick={() => this.setState({ showPanel: false })} />
                <div style={ps.panel}>
                    <div style={ps.header}>
                        <h5 style={ps.title}>Analyte Details</h5>
                        <div>
                            <button style={ps.editBtn} onClick={() => { this.setState({ showPanel: false }); this.handleShow(); }}><i className="fas fa-pen" style={{ marginRight: 5 }}></i>Edit</button>
                            <button style={ps.closeBtn} onClick={() => this.setState({ showPanel: false })}><i className="fas fa-times"></i></button>
                        </div>
                    </div>
                    <div style={ps.body}>
                        <div style={ps.section}>
                            <div style={ps.sectionTitle}>Analyte Information</div>
                            <dl style={ps.dl}>
                                <dt style={ps.dt}>Name</dt><dd style={ps.dd}>{d.name || '—'}</dd>
                                <dt style={ps.dt}>Abbreviation</dt><dd style={ps.dd}>{d.abbreviation || '—'}</dd>
                                <dt style={ps.dt}>Units</dt><dd style={ps.dd}>{d.units || '—'}</dd>
                                <dt style={ps.dt}>Result Type</dt><dd style={ps.dd}>{d.resultType || '—'}</dd>
                                <dt style={ps.dt}>Loinc Code</dt><dd style={ps.dd}>{d.loincCode || '—'}</dd>
                                <dt style={ps.dt}>Specimen Type</dt><dd style={ps.dd}>{d.specimenType || '—'}</dd>
                                <dt style={ps.dt}>Method</dt><dd style={ps.dd}>{d.method || '—'}</dd>
                                <dt style={ps.dt}>Instrument</dt><dd style={ps.dd}>{(d.instrument && (d.instrument.name || (typeof d.instrument === 'string' ? d.instrument : ''))) || d.instrumentName || '—'}</dd>
                                <dt style={ps.dt}>Detection Window</dt><dd style={ps.dd}>{d.detection_window || '—'}</dd>
                                <dt style={ps.dt}>Turnaround</dt><dd style={ps.dd}>{d.turnaroundTime || d.tat || '—'}</dd>
                                <dt style={ps.dt}>Created By</dt><dd style={ps.dd}>{d.createdBy || '—'}</dd>
                            </dl>
                        </div>
                        {d.description && <div style={ps.section}><div style={ps.sectionTitle}>Description</div><div style={{ fontSize: '13px', color: '#222' }}>{d.description}</div></div>}
                        {(() => {
                            const nice = (k) => k.replace(/_/g, ' ').replace(/([a-z])([A-Z])/g, '$1 $2').replace(/^./, (s) => s.toUpperCase());
                            const show = (v) => (v === null || v === undefined || v === '' ? '—' : typeof v === 'object' ? (v.name || v.label || JSON.stringify(v)) : String(v));
                            const table = (title, rows) => {
                                const list = (rows || []).filter(Boolean);
                                if (!list.length) return null;
                                const keys = [...new Set(list.flatMap((r) => Object.keys(r).filter((k) => !['_id', 'id', '__v'].includes(k))))];
                                return (
                                    <div style={ps.section}>
                                        <div style={ps.sectionTitle}>{title}</div>
                                        <table className="table table-sm mb-0" style={{ fontSize: 12 }}>
                                            <thead><tr>{keys.map((k) => <th key={k} style={{ whiteSpace: 'nowrap' }}>{nice(k)}</th>)}</tr></thead>
                                            <tbody>{list.map((r, i) => <tr key={i}>{keys.map((k) => <td key={k}>{show(r[k])}</td>)}</tr>)}</tbody>
                                        </table>
                                    </div>
                                );
                            };
                            const meds = (d.medications || []).map((m) => (m && (m.name || m.label)) || '').filter(Boolean);
                            return (
                                <>
                                    {table('Reference Ranges', d.referenceRanges)}
                                    {table('Critical Values', d.criticalValues)}
                                    {meds.length > 0 && (
                                        <div style={ps.section}>
                                            <div style={ps.sectionTitle}>Medications (Tox Review)</div>
                                            <div>{meds.map((m) => <span key={m} style={{ display: 'inline-block', padding: '2px 10px', margin: '2px 4px 2px 0', borderRadius: 12, background: '#eef2f7', fontSize: 12 }}>{m}</span>)}</div>
                                        </div>
                                    )}
                                </>
                            );
                        })()}
                    </div>
                </div>
            </>,
            document.body
        );
    }

    renderTooltipEdit = (props) => (
        <Tooltip id="button-tooltip" {...props}>
            Edit Analyte
        </Tooltip>
    );

    renderTooltipDelete = (props) => (
        <Tooltip id="button-tooltip" {...props}>
            Delete Analyte
        </Tooltip>
    );

    renderTooltipQcRange = (props) => {
        return (
            <Tooltip id="button-tooltip" {...props}>
                {'QC Ranges'}
            </Tooltip>
        );
    };

    render() {
        return (
            <div>
                <OverlayTrigger placement="top" delay={{ show: 50, hide: 100 }} overlay={<Tooltip id="button-tooltip">View Analyte</Tooltip>}>
                    <button onClick={() => this.setState({ showPanel: true })} className="edit-order-btn"><i className="fas fa-eye"></i></button>
                </OverlayTrigger>
                {this.state.showPanel && this.renderPanel()}
                <OverlayTrigger placement="top" delay={{ show: 50, hide: 100 }} overlay={this.renderTooltipEdit}>
                    <button onClick={this.handleShow} className="edit-order-btn">
                        <i className="fas fa-pen"></i>
                    </button>
                </OverlayTrigger>
                <OverlayTrigger placement="top" delay={{ show: 50, hide: 100 }} overlay={this.renderTooltipQcRange}>
                    <button onClick={this.handleShowQcRangePopup} className="edit-order-btn">
                        <i className="fas fa-vials"></i>
                    </button>
                </OverlayTrigger>
                <OverlayTrigger placement="top" delay={{ show: 50, hide: 100 }} overlay={this.renderTooltipDelete}>
                    <button onClick={this.handleDelete} className="edit-order-btn">
                        <i className="fas fa-trash"></i>
                    </button>
                </OverlayTrigger>
                <ModalStyled
                    size="lg"
                    aria-labelledby="contained-modal-title-vcenter"
                    centered
                    show={this.state.show}
                    onHide={this.handleClose}
                    backdrop="static"
                >
                    <Modal.Header closeButton>
                        <Modal.Title>Update Analyte Information</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <AnalyteDetails
                            analyteId={this.state.analyteId}
                            context={this.props.context}
                            handleClose={this.handleClose}
                        />
                    </Modal.Body>
                </ModalStyled>
                <ModalStyled
                    size="xl"
                    aria-labelledby="contained-modal-title-vcenter"
                    centered
                    show={this.state.showQcPopup}
                    onHide={this.handleCloseQcRangePopup}
                    backdrop="static"
                >
                    <Modal.Header closeButton>
                        <Modal.Title>QC Range for {this.props.data.name}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        {this.state.matchingQcRanges.length !== 3 && (
                            <div className="d-flex justify-content-end">
                                <btn className="btn btn-primary" onClick={this.handleShowQcRangeCreatePopup}>
                                    Add QC Range
                                </btn>
                            </div>
                        )}
                        <div
                            style={{
                                width: '100%',
                                height: '240px',
                                padding: '15px 0px'
                            }}
                        >
                            <ThemeContext.Consumer>
                                {({ themeName }) => (
                                    <div
                                        id="myGrid"
                                        style={{
                                            height: '100%',
                                            width: '100%'
                                        }}
                                    >
                                        <AgGridReact
                                            columnDefs={this.state.columnDefs}
                                            defaultColDef={{
                                                flex: 1,
                                                filter: true,
                                                sortable: true
                                            }}
                                            rowData={this.state.matchingQcRanges}
                                            theme={themeName === 'Light' ? themeLight : themeDark}
                                            components={this.state.components}
                                            context={{
                                                componentParent: {
                                                    loadGridData: this.loadQcRanges
                                                }
                                            }}
                                        />
                                    </div>
                                )}
                            </ThemeContext.Consumer>
                        </div>
                        <ModalStyled
                            size="lg"
                            aria-labelledby="contained-modal-title-vcenter"
                            centered
                            show={this.state.showQcCreatePopup}
                            onHide={this.handleCloseQcRangeCreatePopup}
                            backdrop="static"
                        >
                            <Modal.Header closeButton>
                                <Modal.Title>Add QC Range for {this.props.data.name}</Modal.Title>
                            </Modal.Header>
                            <Modal.Body>
                                <QcRangeDetails
                                    context={{
                                        componentParent: {
                                            loadGridData: this.loadQcRanges
                                        }
                                    }}
                                    handleClose={this.handleCloseQcRangeCreatePopup}
                                    analyteId={this.props.data._id}
                                    controlTypes={qcControlTypes.filter(
                                        (item) =>
                                            !this.state.matchingQcRanges.find((qcRange) => qcRange.controlType === item)
                                    )}
                                />
                            </Modal.Body>
                        </ModalStyled>
                    </Modal.Body>
                </ModalStyled>
            </div>
        );
    }
}
